'use client'
import {
  LinkProps,
  NormalizedSection,
  OpeningTitleProps,
  TagClusterProps,
  TitleProps,
} from '@/types'
import {
  Anchor,
  OpeningTitle,
  Section,
  Tag,
  Title,
} from '@dynamo-caffeina-dev/airc-ui-kit'
import Link from 'next/link'

export interface RecipeTitleProps extends NormalizedSection {
  modelledContent: {
    openingTitle: OpeningTitleProps
    title: TitleProps
    tagCluster: TagClusterProps
    cta: LinkProps
  }
}

function RecipeTitle({ modelledContent }: RecipeTitleProps) {
  const { openingTitle, title, tagCluster, cta } = modelledContent

  const openingTitleLabel = openingTitle?.content
  const titleLabel = title?.content
  const ctaLabel = cta?.label

  const renderTagCluster = () => {
    if (!tagCluster || tagCluster.length === 0) return null

    return tagCluster.map((tag, index: number) => {
      if (!tag || !tag.label) return null

      return (
        <Tag
          key={index}
          className='section-recipe-title__content-wrapper__tag-cluster__tag'
          icon={tag.icon}
        >
          {tag.label}
        </Tag>
      )
    })
  }
  return (
    <Section className='section-recipe-title'>
      <div className='section-recipe-title__content-wrapper'>
        <div className='section-recipe-title__content-wrapper__title-wrapper'>
          {openingTitleLabel ? (
            <OpeningTitle
              className={`section-recipe-title__content-wrapper__title-wrapper__opening-title`}
              {...openingTitle}
            >
              {openingTitleLabel}
            </OpeningTitle>
          ) : null}
          {titleLabel ? (
            <Title
              className={`section-recipe-title__content-wrapper__title-wrapper__title`}
              {...title}
              dangerouslySetInnerHTML={{ __html: titleLabel }}
            />
          ) : null}
        </div>
        <div className='section-recipe-title__content-wrapper__tag-cluster'>
          {renderTagCluster()}
        </div>
        {cta && ctaLabel ? (
          <Anchor
            className='section-recipe-title__content-wrapper__cta link-button-themed'
            as={Link}
            {...cta}
          >
            {ctaLabel}
          </Anchor>
        ) : null}
      </div>
    </Section>
  )
}

export default RecipeTitle
